import { useInfiniteQuery } from "@tanstack/react-query";
import { getLexiconConceptsBySubjectApiLexiconSubjectSubjectGet } from "@noa/api-core";
import { LexiconQueryKey } from "../../query-keys";
import type { AppLanguageType } from "@noa/i18n";

const CONCEPTS_PAGE_LIMIT = 100;

const fetchConceptsPage = async (subject: string, lang: AppLanguageType, cursor?: string | null) => {
  const { data } = await getLexiconConceptsBySubjectApiLexiconSubjectSubjectGet({
    path: { subject },
    query: { lang, limit: CONCEPTS_PAGE_LIMIT, cursor: cursor ?? undefined },
    throwOnError: true,
  });
  return data;
};

export const useGetLexiconConceptBySubject = (subject: string, lang: AppLanguageType, isEnabled: boolean) => {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isPending, ...rest } = useInfiniteQuery({
    queryKey: LexiconQueryKey.conceptsBySubject(subject),
    queryFn: ({ pageParam }) => fetchConceptsPage(subject, lang, pageParam),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.next_cursor ?? undefined,
    enabled: !!subject && isEnabled,
  });

  const concepts = data?.pages.flatMap((p) => p.concepts) ?? [];

  return {
    concepts,
    isLoadingConcepts: isPending && isEnabled,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    ...rest,
  };
};
